import { locationReducer } from "../reducer/LocationReducer";

export const reducer = locationReducer;
